import _ from 'lodash';
import Vue from 'vue';
import { HTTP, SEARCH } from '@/utils/http';
import * as actions from '../types/actions';
import * as getters from '../types/getters';
import * as mutations from '../types/mutations';

const defaultChannel = {
  itunes_image: {},
  _embedded: {
    artwork: {},
  },
};

export default {
  actions: {
    async [actions.DO_CREATE_CHANNEL]({ commit }, params) {
      const { data } = await HTTP.post('/channels', params);
      commit(mutations.SET_CHANNEL, data.data.channels[0]);
      return data;
    },
    async [actions.DO_GET_CHANNEL]({ commit }, payload) {
      const { id, ...params } = payload;
      const { data } = await HTTP.get(`/channels/${id}`, { params });
      commit(mutations.SET_CHANNEL, data.data.channels[0]);
      return data;
    },
    async [actions.DO_GET_CHANNELS]({ commit }, params) {
      const { data } = await HTTP.get('/channels', { params });
      commit(mutations.SET_CHANNEL, data.data.channels);
      return data;
    },
    async [actions.DO_SEARCH_CHANNELS]({ commit }, payload) {
      const { data } = await SEARCH.post('/doxa_channels/channel/_search', payload);
      const channels = data.hits.hits.map(h => h._source);
      commit(mutations.SET_CHANNELS, channels);
      return data;
    },
    async [actions.DO_UPDATE_CHANNEL]({ commit }, payload) {
      const { id, ...params } = payload;
      const { data } = await HTTP.patch(`/channels/${id}`, params);
      commit(mutations.SET_CHANNEL, data.data.channels[0]);
      return data;
    },
  },
  getters: {
    [getters.GET_CHANNEL]: state => state.channel,
    [getters.GET_CHANNELS]: state => state.channels,
  },
  mutations: {
    [mutations.SET_CHANNEL](state, channel) {
      state.channel = channel;
    },
    [mutations.SET_CHANNEL_FIELD](state, field) {
      const nodes = field.key.split('.');
      let obj = state.channel;
      let i = 0;
      nodes.forEach((node) => {
        i += 1;
        if (i === nodes.length) {
          Vue.set(obj, node, field.val);
        } else {
          obj = obj[node];
        }
      });
    },
    [mutations.SET_CHANNELS](state, channels) {
      state.channels = channels;
    },
    [mutations.UNSET_CHANNEL](state) {
      state.channel = _.cloneDeep(defaultChannel);
    },
  },
  state: {
    channel: _.cloneDeep(defaultChannel),
    channels: [],
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/channel.js